import {useMemo} from 'react';
import {Box, Typography} from '@mui/material';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {ReactComponent as LeftIcon} from '@icons/arrow-left.svg';
import {UserMobHeaderStyles} from './UserMobHeader.styles';

const UserMobHeader = () => {
	const {slug} = useParams();
	const location = useLocation();
	const navigate = useNavigate();

	const title = useMemo(() => {
		const path = location.pathname;

		if (path === `/${slug}/profile/contributions`) return 'Contributions';
		if (path === `/${slug}/account-settings`) return 'Account settings';
		if (path === `/${slug}/profile/notifications`) return 'Notifications';
		if (path === `/${slug}/profile/general`) return 'Profile';
		if (path === `/${slug}/raffle/buy-ticket`) return 'Buy Raffle Tickets';
		if (path === `/${slug}/purchase-tickets`) return 'Buy Tickets';

		if (path.startsWith(`/${slug}/tables/details/`)) {
			return 'My Tables & Tickets Details';
		}

		return '';
	}, [location.pathname, slug]);

	return (
		<Box sx={UserMobHeaderStyles.container}>
			<LeftIcon onClick={() => navigate(-1)} />
			<Typography sx={UserMobHeaderStyles.title}>{title}</Typography>
		</Box>
	);
};

export default UserMobHeader;
